import { render, staticRenderFns } from "./LinkedPerishablesListing.vue?vue&type=template&id=d84c3950"
import script from "./LinkedPerishablesListing.vue?vue&type=script&lang=js"
export * from "./LinkedPerishablesListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports